/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.temp.checkHandleAvailability'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  birthDate: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'datetime' }),
  ),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  result: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<ResultAvailable>((() => resultAvailable) as any),
      /*#__PURE__*/ l.typedRef<ResultUnavailable>(
        (() => resultUnavailable) as any,
      ),
    ],
    false,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Checks whether the provided handle is available. If the handle is not available, available suggestions will be returned. Optional inputs will be used to generate suggestions. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['InvalidEmail'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** Indicates the provided handle is available. */
type ResultAvailable = {
  $type?: 'com.atproto.temp.checkHandleAvailability#resultAvailable'
}

export type { ResultAvailable }

/** Indicates the provided handle is available. */
const resultAvailable = /*#__PURE__*/ l.typedObject<ResultAvailable>(
  $nsid,
  'resultAvailable',
  /*#__PURE__*/ l.object({}),
)

export { resultAvailable }

/** Indicates the provided handle is unavailable and gives suggestions of available handles. */
type ResultUnavailable = {
  $type?: 'com.atproto.temp.checkHandleAvailability#resultUnavailable'

  /**
   * List of suggested handles based on the provided inputs.
   */
  suggestions: Suggestion[]
}

export type { ResultUnavailable }

/** Indicates the provided handle is unavailable and gives suggestions of available handles. */
const resultUnavailable = /*#__PURE__*/ l.typedObject<ResultUnavailable>(
  $nsid,
  'resultUnavailable',
  /*#__PURE__*/ l.object({
    suggestions: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<Suggestion>((() => suggestion) as any),
    ),
  }),
)

export { resultUnavailable }

type Suggestion = {
  $type?: 'com.atproto.temp.checkHandleAvailability#suggestion'
  handle: l.HandleString

  /**
   * Method used to build this suggestion. Should be considered opaque to clients. Can be used for metrics.
   */
  method: string
}

export type { Suggestion }

const suggestion = /*#__PURE__*/ l.typedObject<Suggestion>(
  $nsid,
  'suggestion',
  /*#__PURE__*/ l.object({
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    method: /*#__PURE__*/ l.string(),
  }),
)

export { suggestion }
